import axios from "src/service/axios_c";
import ProductCompareRepository from "../repository/ProductCompareRepository";
import { __remove, __set } from "../store/axios_indicator";
import System from "src/helper/system";
import Helper from "src/support/Helper";
import liveAuth from "src/helper/liveAuth";
const storageName = 'PRODUCT_COMPARE_API__' + System.getCurrentSiteSpeedboat()
const storageMeta = "PRODUCT_COMPARE_API_META_" + System.getCurrentSiteSpeedboat()
const avUserInfo = liveAuth.getAvUserInfo()
const metaData = avUserInfo?.account

class ProductCompareAPICall {
    getAll = async () => {
        __set('PRODUCT_COMPARE_API_CALL');
        let data = {};
        let res = {};
        const getMetaData = localStorage.getItem(storageMeta);

        /** Trilok Sain - 27-02-2023 - Clear compare product bucket when user sign out or sign in and remove produce which do not have access//  **/
        const isUserStayPreState = metaData?.accountNumber ? "login" : "logout"
        if (isUserStayPreState === getMetaData) {
            if (localStorage.getItem(storageName)) {
                data = JSON.parse(localStorage.getItem(storageName));
            }
        } else {
            this.removeAll();
        }
        res.data = data;
        __remove('PRODUCT_COMPARE_API_CALL');
        return res;
    };
    setAll = async (data) => {
        __set('PRODUCT_COMPARE_API_CALL');
        let res = {};
        localStorage.setItem(storageName, JSON.stringify(data));
        localStorage.setItem(storageMeta, metaData?.accountNumber ? "login" : "logout")
        __remove('PRODUCT_COMPARE_API_CALL');
        return res;
    };
    removeAll = async () => {
        __set('PRODUCT_COMPARE_API_CALL');
        let res = {};
        localStorage.removeItem(storageName);
        localStorage.removeItem(storageMeta);
        __remove('PRODUCT_COMPARE_API_CALL');
        return res;
    };
    axiosCall = (url, data = {}, method = 'post') => {
        data = this.mergeDataWithBase(data);
        let config = {
            method: method,
            url: url,
            /* headers: {
                'accept': 'text/plain',
                'Content-Type': 'application/json-patch+json'
            }, */
            headers: Helper.getCommonHeader(method),
            data: data
        };
        if (config.method !== 'post' && config.method !== 'POST') {
            config.params = data;
        }
        return axios(config);
    };
    mergeDataWithBase = (data) => {
        let ProductCompare = new ProductCompareRepository();
        if (!data.sessionUUId) {
            data.sessionUUId = ProductCompare.getSessionUUID();
        }
        data.key = 'ProductCompare';
        return data;
    };
}

export default ProductCompareAPICall;